import generateRender from 'shared/utils/generateRender';
import DefaultSignupTemplate from './DefaultSignupTemplate';

const SignupTemplate = generateRender({
  default: DefaultSignupTemplate,
});

export default SignupTemplate;

